// extracted by mini-css-extract-plugin
module.exports = {"imageText":"careers_imageText__3u_f4","picture1":"careers_picture1__FoVLK","paragraph1":"careers_paragraph1__3QuFx"};